import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

interface BackIconProps extends SVGProps<SVGSVGElement> {
    color?: string;
    width?: number;
    height?: number;
    className?: string;
    svgProps?: SVGProps<SVGSVGElement>;
}

const BackIcon = ({ color = 'currentColor', width = 24, height = 18, className, svgProps }: BackIconProps) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 23 18" fill="none" className={className} {...svgProps}>
            <path d="M9.40213 1.69223L1.4301 8.99993L9.40213 16.3076" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M21.57 8.99902H1.56996" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
        </svg>
    );
};

export default BackIcon;
